import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="about-page">
      <Navbar />
      <div className="h-20" />

      <div className="bg-gradient-to-br from-[#FDF8F4] to-[#F4EDE4] py-16 px-6 md:px-10 lg:px-20">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">About MealHoster</h1>
          <p className="text-lg text-gray-600 italic">Every great idea begins with a table.</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-10 py-14">
        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p>
            Every great idea begins with a table. Not a boardroom table. Not a restaurant reservation. Just a table where people gather, stories unfold, and strangers leave as friends.
          </p>

          <p>
            In 2015, during a work trip, a passionate foodie named Rishi Shinn found himself far from home in a small village in Northern India. One evening, he invited four friends to his grandmother's house for dinner — nothing fancy, no Michelin stars, no curated tasting menu. Just a home kitchen, a decades-old recipe, and what would later be remembered as probably the best butter chicken they'd ever tasted.
          </p>

          <p>
            Neighbours popped in to see who was visiting. Laughter echoed between courses. Ingredients came fresh from nearby farms, cooked with care rather than ceremony. What unfolded that night wasn't just a meal — it was hospitality in its purest form. The food was unforgettable. But the feeling stayed longer.
          </p>

          <p>
            Inspired by that experience, Rishi and his friends began hosting each other back home. Living rooms turned into dining spaces. Kitchens became stages for creativity. Every gathering became a "meal experience" — sometimes elaborate, sometimes simple, always meaningful. The food was always good. The memories made were indelible.
          </p>

          <p>
            Word spread quickly. Friends invited friends. Soon, friends of friends were emailing Rishi with recommendations for meal experiences he had to try whenever he travelled. Wherever he went — whether on holiday or work — he sought out local chefs, supper clubs, dim sum making classes, and hidden home kitchens. And over time, something became clear: It wasn't just about the food. It was the unique blend of <strong>connection, belonging, and sharing</strong> that transformed a meal into something worth writing home about.
          </p>

          <p>
            That growing list of unforgettable experiences became the seed for MealHoster.
          </p>

          <p>
            Travel can mean the same kind of menu in every city. MealHoster is for people who would rather skip the tourist table and eat where locals eat — in their homes, with the people who cook the food.
          </p>

          <p>
            Today, MealHoster brings together a growing community of hosts and guests, starting in London, who believe that the best meals aren't found — they're shared. We exist to help people open their homes, their cultures, and their stories to others through meaningful meal experiences.
          </p>

          <p>
            Whether you're hosting a family recipe passed down through generations, teaching travellers how to cook a local favourite, or simply gathering people around a table to connect — MealHoster is where memories begin.
          </p>

          <div className="bg-[#FDF8F4] rounded-xl p-6 my-8">
            <p className="font-semibold text-gray-900 mb-3">We believe:</p>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-[#D65A31] mt-1 font-bold">&bull;</span>
                <span>A home can be the world's most memorable restaurant.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D65A31] mt-1 font-bold">&bull;</span>
                <span>Food is a universal language.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D65A31] mt-1 font-bold">&bull;</span>
                <span>Strangers are just friends who haven't shared a meal yet.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#D65A31] mt-1 font-bold">&bull;</span>
                <span>The stories told around a table matter as much as the dishes served.</span>
              </li>
            </ul>
          </div>

          <p>
            MealHoster isn't just a platform. It's a growing community built on warmth, curiosity, and human connection — one meal experience at a time.
          </p>

          <p className="text-xl font-semibold text-gray-900 text-center pt-4">
            Pull up a chair. Share your table. Be part of the MealHoster story.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutPage;
